<template>
  <!-- 弹窗显示上刊照片反馈 -->
  <Modal v-model="showDemandImage" width="1000" :footer-hide="true">
      <p slot="header" class="text-center">
          <Icon type="ios-information-circle"></Icon>
          <span>灯箱编号：{{chooseResouceCode}}
          <Icon type="ios-analytics" class="p-l-5" />
          (
            <span v-if="demandBrand !== ''">发布品牌：<span class="text-orange">{{demandBrand}}</span> </span>
          )
          </span>
      </p>
      <div class="text-center">
        <Row class="p-b-5">
          <i-col span="24">
              <div @click="handleChangeType(1)" :class="choosePhoneType === 1?'workplatform-radio-button-active':'workplatform-radio-button'" class="p-l-20 p-r-20">任务素材</div>
              <div @click="handleChangeType(2)" :class="choosePhoneType === 2?'workplatform-radio-button-active':'workplatform-radio-button'" class="p-l-20 p-r-20">上刊反馈</div>
          </i-col>
        </Row>
        <img-light-box-component v-show="choosePhoneType === 1" ref="demandImgLightBox" :imgIndex.sync="demandImgIndex"/>
        <img-light-box-component v-show="choosePhoneType === 2" ref="workImgLightBox" :imgIndex.sync="workImgIndex"/>
      </div>
  </Modal>
</template>

<script>
import ImgLightBoxComponent from '@/components/common/ImgLightBox'

// apis
// import { getStaionTaskList } from '@/api/msp/search'

export default {
  components: {
    ImgLightBoxComponent
  },
  data () {
    return {
      showDemandImage: false,

      // 上刊反馈参数
      chooseResouceCode: '',
      demandBrand: '',

      choosePhoneType: 1,
      demandPhotoList: [], // 上刊素材照片列表
      demandImgIndex: 0,
      workPhotoList: [], // 工单照片
      workImgIndex: 0
    }
  },
  methods: {
    showModal (params) {
      this.showDemandImage = true

      if (params) {
        this.chooseResouceCode = params.code
        this.demandBrand = params.brandName
        this.demandPhotoList = params.installAttachList
        this.workPhotoList = params.backAttachList

        this.handleChangeType(1)
      }
    },
    handleChangeType (type) {
      this.choosePhoneType = type

      const postData = {
        startIndex: 0,
        imgList: []
      }

      if (type === 1) { // 任务素材
        postData.startIndex = this.demandImgIndex
        postData.imgList = this.demandPhotoList.map(x => x.filePath)
        this.$refs.demandImgLightBox.init(postData)
      } else { // 反馈照片
        postData.startIndex = this.workImgIndex
        postData.imgList = this.workPhotoList.map(x => x.filePath)
        this.$refs.workImgLightBox.init(postData)
      }
    }
  }
}
</script>
